(() => {
  const STAIN_DATA = {
    grease: {
      label: 'vet of olie',
      first: 'Neem overtollig vet weg met een lepel of bot mes. Dep vloeistof met een schone witte doek en werk van buiten naar binnen.',
      driedFirst: 'Schraap opgedroogde resten voorzichtig weg. Maak de plek niet heet en probeer het vet niet verder in de vezels te wrijven.',
      pre: 'Breng op een wasbare, stevige stof vloeibaar wasmiddel of een geschikte voorwas-vlekverwijderaar aan. Volg de inwerktijd op het productetiket.',
      wash: 'Was daarna op de hoogste temperatuur die het waslabel toestaat. Controleer de plek voordat u warmte gebruikt.',
      avoid: 'Niet hard wrijven en niet in de droger of onder een heet strijkijzer zolang de vlek zichtbaar is.',
    },
    blood: {
      label: 'bloed',
      first: 'Neem overtollig bloed direct op en spoel de vlek vanaf de achterzijde met koud water.',
      driedFirst: 'Week of spoel de ingedroogde plek eerst met koud water. Geef het water tijd om de vlek losser te maken.',
      pre: 'Gebruik bij een wasbare, stevige stof een voorbehandeling die volgens het etiket geschikt is voor bloed en de gekozen stof. Een enzymhoudend middel is niet geschikt voor alle vezels.',
      wash: 'Was volgens het waslabel. Begin koud en gebruik geen hogere temperatuur dan het label toestaat.',
      avoid: 'Geen heet water: warmte kan bloedvlekken vastzetten. Gebruik geen enzymmiddel op wol of zijde.',
    },
    wine: {
      label: 'rode wijn',
      first: 'Dep zo veel mogelijk wijn op met een schone witte doek. Spoel of week de plek vervolgens met koel water.',
      driedFirst: 'Maak de ingedroogde plek voorzichtig vochtig met koel water en dep losgekomen kleurstof op met een schone witte doek.',
      pre: 'Behandel een wasbare, stevige stof voor met een geschikte voorwas-vlekverwijderaar. Volg het productetiket en test de kleurvastheid.',
      wash: 'Was volgens het waslabel en controleer de vlek na afloop. Herhaal zo nodig vóór het drogen.',
      avoid: 'Niet hard wrijven. Gebruik alleen een bleekmiddel als zowel het waslabel als het productetiket dit voor deze stof en kleur toestaan.',
    },
    coffee: {
      label: 'koffie of thee',
      first: 'Dep overtollige vloeistof en spoel de vlek vanaf de achterzijde met koel stromend water.',
      driedFirst: 'Maak de opgedroogde plek met koel water vochtig en dep voorzichtig. Herhaal totdat er minder kleur afgeeft.',
      pre: 'Breng op een wasbare, stevige stof vloeibaar wasmiddel of een geschikte voorbehandeling aan volgens het productetiket.',
      wash: 'Was op de hoogste temperatuur die het waslabel toestaat en controleer de plek voordat u het kledingstuk droogt.',
      avoid: 'Niet direct heet drogen of strijken. Wrijf niet zo hard dat de stof of kleur verandert.',
    },
    makeup: {
      label: 'make-up of lippenstift',
      first: 'Schep of dep overtollige make-up voorzichtig weg zonder het pigment over een groter oppervlak te verspreiden.',
      driedFirst: 'Verwijder droge resten voorzichtig. Dep de plek; schrob het pigment niet dieper in de vezels.',
      pre: 'Gebruik een voorbehandeling die geschikt is voor cosmetica én voor de stof. Cosmetica kan olie, was en pigment bevatten, waardoor herhalen nodig kan zijn.',
      wash: 'Was volgens het waslabel en laat aan de lucht drogen als er nog verkleuring zichtbaar is.',
      avoid: 'Gebruik geen willekeurig oplosmiddel. Sommige middelen lossen de vlek op, maar kunnen ook kleur, print of vezel aantasten.',
    },
    grass: {
      label: 'gras',
      first: 'Verwijder los vuil en dep de plek met koel water. Wrijf de groene kleur niet verder in de vezels.',
      driedFirst: 'Borstel losse droge resten weg en maak de resterende vlek voorzichtig vochtig met koel water.',
      pre: 'Gebruik op een wasbare, stevige stof een enzymhoudende voorbehandeling als het productetiket dit voor de stof toestaat.',
      wash: 'Was daarna volgens het waslabel en controleer vóór het drogen.',
      avoid: 'Geen standaard enzymbehandeling op wol of zijde. Gebruik geen chloorbleek op gekleurde of donkere stof.',
    },
    sweat: {
      label: 'zweet of deodorant',
      first: 'Spoel de plek met koel water en druk overtollig vocht voorzichtig uit zonder de stof uit te rekken.',
      driedFirst: 'Maak de plek met koel water vochtig en laat dit kort intrekken voordat u voorbehandelt.',
      pre: 'Behandel een wasbare, stevige stof voor met vloeibaar wasmiddel of een geschikt vlekproduct en volg de aangegeven inwerktijd.',
      wash: 'Was volgens het waslabel. Controleer vooral de okselzone na het wassen voordat u warmte gebruikt.',
      avoid: 'Niet hard schrobben en geen bleekmiddel gebruiken zonder toestemming van het waslabel.',
    },
    chocolate: {
      label: 'chocolade',
      first: 'Haal vaste resten voorzichtig weg. Spoel de vlek vanaf de achterzijde met koel water.',
      driedFirst: 'Schraap droge resten voorzichtig weg en spoel de plek vanaf de achterzijde met koel water.',
      pre: 'Gebruik op een wasbare, stevige stof een geschikt voorbehandelmiddel. Een enzymhoudend middel kan helpen bij voedselresten, maar is niet geschikt voor alle vezels.',
      wash: 'Was volgens het waslabel en controleer de plek voordat u het kledingstuk droogt.',
      avoid: 'Geen heet water aan het begin en geen enzymmiddel op wol of zijde.',
    },
    ink: {
      label: 'inkt',
      first: 'Dep de vlek en voorkom dat de inkt zich verder verspreidt. Leg zo nodig een schone absorberende doek achter de plek.',
      driedFirst: 'Behandel de droge inkt niet blind met een oplosmiddel. Bepaal zo mogelijk eerst welk type inkt het is.',
      pre: 'Gebruik een middel dat volgens het etiket geschikt is voor het type inkt en de stof. Test altijd op een verborgen plek; sommige inkten zijn niet volledig verwijderbaar.',
      wash: 'Spoel het gebruikte voorbehandelmiddel volledig uit en was alleen als het waslabel dit toestaat.',
      avoid: 'Niet wrijven en geen verschillende oplos- of reinigingsmiddelen combineren.',
    },
    mud: {
      label: 'modder',
      first: 'Laat modder eerst drogen. Borstel of schraap daarna zo veel mogelijk losse aarde voorzichtig weg.',
      driedFirst: 'Borstel de droge modder buiten of boven een afvalbak weg zonder de stof te beschadigen.',
      pre: 'Behandel de resterende plek op een wasbare, stevige stof met vloeibaar wasmiddel of een geschikt voorwasmiddel.',
      wash: 'Was volgens het waslabel en controleer na afloop of er nog verkleuring zichtbaar is.',
      avoid: 'Wrijf natte modder niet verder uit en gebruik geen droger zolang er nog een vlek zichtbaar is.',
    },
  };

  const FABRIC_LABELS = {
    cotton: 'katoen of linnen',
    synthetic: 'synthetische stof',
    denim: 'denim',
    wool: 'wol',
    silk: 'zijde of zeer delicate stof',
    unknown: 'onbekende stof',
  };

  const STATUS_LABELS = {
    fresh: 'een verse vlek',
    dried: 'een ingedroogde vlek',
    washed: 'een al gewassen vlek',
  };

  const COLOR_LABELS = {
    light: 'lichte stof',
    colored: 'gekleurde stof',
    dark: 'donkere stof',
  };

  const TRANSLATIONS = {
    nl: {
      stains: STAIN_DATA,
      fabrics: FABRIC_LABELS,
      statuses: STATUS_LABELS,
      colors: COLOR_LABELS,
      ui: {
        next: 'Volgende',
        showAdvice: 'Bekijk mijn advies',
        homeBadge: 'Voorzichtig thuis behandelen',
        woolBadge: 'Extra voorzichtig met wol',
        professionalBadge: 'Professionele reiniging aangeraden',
        unknownBadge: 'Bepaal eerst stof en waslabel',
        title: (stain, fabric) => `${capitalizeText(stain)} uit ${fabric}`,
        washedFirst: (driedFirst) => `Gebruik geen extra warmte meer. Maak de plek opnieuw voorzichtig vochtig met koel water en dep losgekomen vuil op. ${driedFirst}`,
        washedPre: ' Bij een al gewassen of gedroogde vlek kan herhalen nodig zijn en is volledige verwijdering niet altijd mogelijk.',
        woolBlood: 'Neem overtollig bloed op met een absorberende doek en dep de plek voorzichtig met koud water.',
        woolCoffee: 'Spoel een verse koffievlek voorzichtig met koud water. Dep een ingedroogde plek met een pluisvrije doek en lauw water.',
        woolMud: 'Laat modder drogen en borstel losse aarde zeer voorzichtig weg zonder aan de wolvezels te trekken.',
        woolPre: 'Dep vanaf de rand met een pluisvrije doek en een verdunde oplossing van een voor wol goedgekeurd wasmiddel in lauw water. Gebruik weinig vocht en volg het kledinglabel.',
        woolWash: 'Was alleen als het waslabel dit toestaat, met het aangegeven wol- of handwasprogramma en een voor wol geschikt middel. Kies professionele reiniging als het label dat voorschrijft.',
        woolAvoid: 'Niet wrijven, trekken of uitwringen. Gebruik geen standaard enzymmiddel, chloorbleek of willekeurig oplosmiddel op wol.',
        inkWoolFirst: 'Dep alleen overtollige inkt met een droge, schone witte doek. Wrijf niet en maak de plek niet ruim nat.',
        inkWoolPre: 'Gebruik op wol niet zelf een universele vlekverwijderaar of oplosmiddel. Inkten en wolafwerkingen reageren verschillend.',
        inkWoolWash: 'Breng het kledingstuk zo snel mogelijk naar een professionele textielreiniger en vertel welk type inkt de vlek heeft veroorzaakt, als u dat weet.',
        inkWoolAvoid: 'Niet wrijven, weken of verschillende reinigingsmiddelen combineren. Warmte en oplosmiddelen kunnen de vlek of wolvezel blijvend aantasten.',
        silkFirst: 'Dep overtollig vuil voorzichtig met een droge, schone witte doek. Niet wrijven en niet ruim natmaken.',
        silkPre: 'Gebruik niet op eigen initiatief een universele vlekverwijderaar, enzymmiddel, bleekmiddel of oplosmiddel. Zijde en zeer delicate afwerkingen kunnen verkleuren of beschadigen.',
        silkWash: 'Volg uitsluitend het waslabel. Staat er niet wassen of professionele reiniging, breng het kledingstuk dan zo snel mogelijk naar een textielreiniger en vertel wat de vlek heeft veroorzaakt.',
        silkAvoid: 'Niet schrobben, weken, wringen, föhnen of combineren met huishoudelijke middeltjes.',
        unknownFirst: 'Dep alleen overtollig vuil met een schone witte doek. Gebruik koel water uitsluitend als het kledingstuk volgens het label nat behandeld mag worden.',
        unknownPre: 'Breng nog geen onbekend reinigingsmiddel aan. Zoek het waslabel en de vezelsamenstelling; test daarna ieder toegestaan middel op een verborgen plek.',
        unknownWash: 'Was pas wanneer duidelijk is dat de stof thuis gewassen mag worden. Kies bij een kostbaar kledingstuk, ontbrekend label of kleurafgifte voor professionele reiniging.',
        unknownAvoid: 'Niet gokken met temperatuur, bleekmiddel, enzymen of oplosmiddelen. Verschillende vezels reageren verschillend.',
        syntheticWash: 'Was volgens het waslabel. Synthetische vezels kunnen gevoelig zijn voor hitte, dus overschrijd de aangegeven temperatuur niet en controleer vóór het drogen.',
        denimPre: ' Denim kan kleur afgeven; test de behandeling daarom op de binnenzijde.',
        darkAvoid: ' Gebruik op donkere stof geen chloorbleek; ook een kleurveilig middel alleen toepassen als waslabel en productetiket dit toestaan.',
        coloredAvoid: ' Controleer gekleurde stof op kleurvastheid en gebruik geen chloorbleek.',
        lightAvoid: ' Ook op lichte stof is bleekmiddel alleen toegestaan als het waslabel en productetiket dit expliciet toelaten.',
        summary: ({ status, stain, color, fabric, professional }) => `Advies voor ${status} van ${stain} op ${color} van ${fabric}. ${professional ? 'De kans op schade is hier belangrijker dan snel thuis doorbehandelen.' : 'Werk rustig, test eerst en controleer het resultaat vóór u warmte gebruikt.'}`,
        shareMessage: (title) => `Mijn FashFresh Vlekkenhulp-stappenplan: ${title}. Het waslabel gaat altijd voor.`,
        shareTitle: 'FashFresh Vlekkenhulp',
        shareText: (title) => `Mijn stappenplan voor ${title.toLowerCase()}. Het waslabel gaat altijd voor.`,
        copiedNative: 'De link is gekopieerd; u kunt hem nu in een app plakken.',
        copied: 'De link is gekopieerd.',
        shareFailed: 'Delen is niet gelukt. Probeer de link handmatig te kopiëren.',
      },
    },
    en: {
      stains: {
        grease: { label: 'grease or oil', first: 'Lift away excess grease with a spoon or blunt knife. Blot liquid with a clean white cloth, working from the outside in.', driedFirst: 'Gently scrape away dried residue. Do not heat the area or rub grease further into the fibres.', pre: 'On a sturdy washable fabric, apply liquid detergent or a suitable pre-wash stain remover. Follow the contact time on the product label.', wash: 'Wash at the highest temperature permitted by the care label. Check the area before using heat.', avoid: 'Do not rub hard or use a dryer or hot iron while the stain is still visible.' },
        blood: { label: 'blood', first: 'Absorb excess blood immediately and rinse the stain from the reverse with cold water.', driedFirst: 'Soak or rinse the dried area with cold water first. Give the water time to loosen the stain.', pre: 'For a sturdy washable fabric, use a pre-treatment whose label says it is suitable for blood and the selected fabric. Enzyme products are not suitable for every fibre.', wash: 'Wash according to the care label. Start cold and do not exceed the permitted temperature.', avoid: 'Do not use hot water: heat can set blood stains. Do not use enzyme products on wool or silk.' },
        wine: { label: 'red wine', first: 'Blot up as much wine as possible with a clean white cloth, then rinse or soak the area in cool water.', driedFirst: 'Gently dampen the dried area with cool water and blot released colour with a clean white cloth.', pre: 'Pre-treat a sturdy washable fabric with a suitable pre-wash stain remover. Follow its label and test colourfastness.', wash: 'Wash according to the care label and inspect after washing. Repeat before drying if needed.', avoid: 'Do not rub hard. Use bleach only when both the care label and product label permit it for this fabric and colour.' },
        coffee: { label: 'coffee or tea', first: 'Blot excess liquid and rinse the stain from the reverse under cool running water.', driedFirst: 'Dampen the dried area with cool water and blot gently. Repeat while colour continues to transfer.', pre: 'On a sturdy washable fabric, apply liquid detergent or a suitable pre-treatment according to its label.', wash: 'Wash at the highest temperature permitted by the care label and inspect before drying.', avoid: 'Do not immediately heat-dry or iron. Avoid rubbing hard enough to alter the fabric or colour.' },
        makeup: { label: 'make-up or lipstick', first: 'Carefully lift or blot away excess make-up without spreading pigment over a larger area.', driedFirst: 'Gently remove dry residue. Blot rather than scrubbing pigment deeper into the fibres.', pre: 'Use a pre-treatment suitable for both cosmetics and the fabric. Cosmetics may contain oil, wax and pigment, so repetition may be needed.', wash: 'Wash according to the care label and air-dry if discolouration is still visible.', avoid: 'Do not use a random solvent. It may dissolve the stain but also damage colour, print or fibres.' },
        grass: { label: 'grass', first: 'Remove loose dirt and blot the area with cool water. Do not rub green pigment further into the fibres.', driedFirst: 'Brush away loose dry residue and gently dampen the remaining stain with cool water.', pre: 'On a sturdy washable fabric, use an enzyme pre-treatment when its product label permits this for the fabric.', wash: 'Wash according to the care label and inspect before drying.', avoid: 'Do not use a standard enzyme treatment on wool or silk. Do not use chlorine bleach on coloured or dark fabric.' },
        sweat: { label: 'sweat or deodorant', first: 'Rinse with cool water and gently press out excess moisture without stretching the fabric.', driedFirst: 'Dampen the area with cool water and let it sit briefly before pre-treatment.', pre: 'Pre-treat a sturdy washable fabric with liquid detergent or a suitable stain product and follow its contact time.', wash: 'Wash according to the care label. Inspect the underarm area before using heat.', avoid: 'Do not scrub hard or use bleach unless the care label permits it.' },
        chocolate: { label: 'chocolate', first: 'Carefully remove solid residue. Rinse the stain from the reverse with cool water.', driedFirst: 'Gently scrape away dry residue and rinse the area from the reverse with cool water.', pre: 'Use a suitable pre-treatment on a sturdy washable fabric. An enzyme product may help with food residue but is not suitable for every fibre.', wash: 'Wash according to the care label and inspect before drying.', avoid: 'Do not start with hot water and do not use enzyme products on wool or silk.' },
        ink: { label: 'ink', first: 'Blot the stain and keep the ink from spreading. Place a clean absorbent cloth behind the area if needed.', driedFirst: 'Do not blindly treat dried ink with a solvent. First identify the type of ink if possible.', pre: 'Use a product whose label says it is suitable for the type of ink and fabric. Always test on a hidden area; some inks cannot be removed completely.', wash: 'Rinse out the pre-treatment fully and wash only when the care label permits it.', avoid: 'Do not rub or combine different solvents or cleaning products.' },
        mud: { label: 'mud', first: 'Let mud dry first, then gently brush or scrape away as much loose soil as possible.', driedFirst: 'Brush off dry mud outdoors or over a bin without damaging the fabric.', pre: 'Treat the remaining area on a sturdy washable fabric with liquid detergent or a suitable pre-wash product.', wash: 'Wash according to the care label and inspect for remaining discolouration.', avoid: 'Do not spread wet mud and do not use a dryer while a stain is still visible.' },
      },
      fabrics: { cotton: 'cotton or linen', synthetic: 'synthetic fabric', denim: 'denim', wool: 'wool', silk: 'silk or a very delicate fabric', unknown: 'an unknown fabric' },
      statuses: { fresh: 'a fresh stain', dried: 'a dried stain', washed: 'a previously washed stain' },
      colors: { light: 'light fabric', colored: 'coloured fabric', dark: 'dark fabric' },
      ui: {
        next: 'Next', showAdvice: 'Show my advice', homeBadge: 'Treat cautiously at home', woolBadge: 'Take extra care with wool', professionalBadge: 'Professional cleaning recommended', unknownBadge: 'Identify the fabric and care label first',
        title: (stain, fabric) => `${capitalizeText(stain)} on ${fabric}`,
        washedFirst: (driedFirst) => `Do not apply any more heat. Gently dampen the area again with cool water and blot released soil. ${driedFirst}`,
        washedPre: ' A previously washed or dried stain may require repetition and may not be completely removable.',
        woolBlood: 'Absorb excess blood with an absorbent cloth and gently blot with cold water.', woolCoffee: 'Gently rinse fresh coffee with cold water. Blot a dried area with a lint-free cloth and lukewarm water.', woolMud: 'Let mud dry and very gently brush away loose soil without pulling the wool fibres.',
        woolPre: 'Blot from the edge with a lint-free cloth and a diluted solution of a wool-approved detergent in lukewarm water. Use little moisture and follow the care label.', woolWash: 'Wash only if the care label permits it, using the specified wool or hand-wash programme and a wool-safe product. Choose professional cleaning when the label requires it.', woolAvoid: 'Do not rub, pull or wring. Do not use standard enzyme products, chlorine bleach or random solvents on wool.',
        inkWoolFirst: 'Only blot excess ink with a dry, clean white cloth. Do not rub or soak the area.', inkWoolPre: 'Do not apply a universal stain remover or solvent to wool yourself. Inks and wool finishes react differently.', inkWoolWash: 'Take the garment to a professional textile cleaner as soon as possible and identify the type of ink if you know it.', inkWoolAvoid: 'Do not rub, soak or combine cleaning products. Heat and solvents can permanently affect the stain or wool fibres.',
        silkFirst: 'Gently blot excess soil with a dry, clean white cloth. Do not rub or soak the area.', silkPre: 'Do not independently use a universal stain remover, enzyme product, bleach or solvent. Silk and delicate finishes may discolour or be damaged.', silkWash: 'Follow only the care label. If it says do not wash or professional clean, take the garment to a textile cleaner promptly and explain what caused the stain.', silkAvoid: 'Do not scrub, soak, wring, blow-dry or combine household remedies.',
        unknownFirst: 'Only blot excess soil with a clean white cloth. Use cool water only when the care label permits wet treatment.', unknownPre: 'Do not apply an unknown cleaning product yet. Find the care label and fibre composition, then test any permitted product on a hidden area.', unknownWash: 'Wash only when you know the fabric may be washed at home. Choose professional cleaning for a valuable garment, a missing label or colour transfer.', unknownAvoid: 'Do not guess with temperature, bleach, enzymes or solvents. Fibres react differently.',
        syntheticWash: 'Wash according to the care label. Synthetic fibres can be heat-sensitive, so do not exceed the stated temperature and inspect before drying.', denimPre: ' Denim can transfer colour, so test the treatment on the inside.', darkAvoid: ' Do not use chlorine bleach on dark fabric; use a colour-safe product only when both labels permit it.', coloredAvoid: ' Test coloured fabric for colourfastness and do not use chlorine bleach.', lightAvoid: ' Even on light fabric, bleach is allowed only when the care label and product label explicitly permit it.',
        summary: ({ status, stain, color, fabric, professional }) => `Advice for ${status}: ${stain} on ${color} made of ${fabric}. ${professional ? 'Avoiding damage matters more here than continuing treatment at home.' : 'Work calmly, test first and inspect the result before using heat.'}`,
        shareMessage: (title) => `My FashFresh stain-guide plan: ${title}. The care label always comes first.`, shareTitle: 'FashFresh Stain Guide', shareText: (title) => `My step-by-step plan for ${title.toLowerCase()}. The care label always comes first.`, copiedNative: 'The link has been copied; you can now paste it into an app.', copied: 'The link has been copied.', shareFailed: 'Sharing failed. Try copying the link manually.',
      },
    },
    fr: {
      stains: {
        grease: { label: 'graisse ou huile', first: 'Retirez l’excédent avec une cuillère ou un couteau non tranchant. Tamponnez le liquide avec un chiffon blanc propre, de l’extérieur vers l’intérieur.', driedFirst: 'Grattez délicatement les résidus secs. Ne chauffez pas la zone et ne faites pas pénétrer la graisse dans les fibres.', pre: 'Sur un tissu résistant et lavable, appliquez une lessive liquide ou un détachant avant lavage adapté. Respectez le temps d’action indiqué sur l’étiquette.', wash: 'Lavez à la température maximale autorisée par l’étiquette d’entretien. Vérifiez la zone avant d’utiliser de la chaleur.', avoid: 'Ne frottez pas fortement et n’utilisez ni sèche-linge ni fer chaud tant que la tache est visible.' },
        blood: { label: 'sang', first: 'Absorbez immédiatement l’excédent et rincez la tache par l’envers à l’eau froide.', driedFirst: 'Faites d’abord tremper ou rincez la zone sèche à l’eau froide. Laissez l’eau agir pour détacher la tache.', pre: 'Sur un tissu résistant et lavable, utilisez un prétraitement indiqué pour le sang et le tissu choisi. Les produits enzymatiques ne conviennent pas à toutes les fibres.', wash: 'Lavez selon l’étiquette d’entretien. Commencez à froid et ne dépassez pas la température autorisée.', avoid: 'N’utilisez pas d’eau chaude : la chaleur peut fixer le sang. N’utilisez pas d’enzymes sur la laine ou la soie.' },
        wine: { label: 'vin rouge', first: 'Tamponnez autant de vin que possible avec un chiffon blanc propre, puis rincez ou faites tremper à l’eau fraîche.', driedFirst: 'Humidifiez délicatement la zone sèche à l’eau fraîche et tamponnez la couleur libérée avec un chiffon blanc propre.', pre: 'Prétraitez un tissu résistant et lavable avec un détachant adapté. Suivez son étiquette et testez la tenue des couleurs.', wash: 'Lavez selon l’étiquette d’entretien et vérifiez après le lavage. Répétez avant le séchage si nécessaire.', avoid: 'Ne frottez pas fortement. N’utilisez un agent blanchissant que si les deux étiquettes l’autorisent pour ce tissu et cette couleur.' },
        coffee: { label: 'café ou thé', first: 'Tamponnez l’excédent et rincez la tache par l’envers sous l’eau fraîche.', driedFirst: 'Humidifiez la zone sèche à l’eau fraîche et tamponnez doucement. Répétez tant que la couleur se transfère.', pre: 'Sur un tissu résistant et lavable, appliquez une lessive liquide ou un prétraitement adapté selon son étiquette.', wash: 'Lavez à la température maximale autorisée par l’étiquette et vérifiez avant le séchage.', avoid: 'Ne séchez pas immédiatement à chaud et ne repassez pas. Ne frottez pas au point d’altérer le tissu ou la couleur.' },
        makeup: { label: 'maquillage ou rouge à lèvres', first: 'Retirez ou tamponnez délicatement l’excédent sans étaler les pigments.', driedFirst: 'Retirez doucement les résidus secs. Tamponnez sans faire pénétrer les pigments plus profondément.', pre: 'Utilisez un prétraitement adapté aux cosmétiques et au tissu. L’huile, la cire et les pigments peuvent nécessiter plusieurs traitements.', wash: 'Lavez selon l’étiquette et séchez à l’air si une coloration reste visible.', avoid: 'N’utilisez pas de solvant au hasard : il peut dissoudre la tache mais aussi endommager la couleur, l’impression ou les fibres.' },
        grass: { label: 'herbe', first: 'Retirez les saletés et tamponnez à l’eau fraîche. Ne faites pas pénétrer davantage le pigment vert.', driedFirst: 'Brossez les résidus secs, puis humidifiez délicatement la tache restante à l’eau fraîche.', pre: 'Sur un tissu résistant et lavable, utilisez un prétraitement enzymatique si son étiquette l’autorise pour le tissu.', wash: 'Lavez selon l’étiquette d’entretien et vérifiez avant le séchage.', avoid: 'N’utilisez pas de traitement enzymatique standard sur la laine ou la soie, ni d’eau de Javel sur les tissus colorés ou foncés.' },
        sweat: { label: 'transpiration ou déodorant', first: 'Rincez à l’eau fraîche et pressez doucement l’excès d’humidité sans étirer le tissu.', driedFirst: 'Humidifiez à l’eau fraîche et laissez agir brièvement avant le prétraitement.', pre: 'Prétraitez un tissu résistant et lavable avec une lessive liquide ou un détachant adapté, en respectant le temps d’action.', wash: 'Lavez selon l’étiquette. Vérifiez notamment la zone des aisselles avant d’utiliser de la chaleur.', avoid: 'Ne frottez pas fortement et n’utilisez pas d’agent blanchissant sans autorisation de l’étiquette.' },
        chocolate: { label: 'chocolat', first: 'Retirez délicatement les résidus solides. Rincez la tache par l’envers à l’eau fraîche.', driedFirst: 'Grattez doucement les résidus secs et rincez par l’envers à l’eau fraîche.', pre: 'Utilisez un prétraitement adapté sur un tissu résistant et lavable. Un produit enzymatique peut aider, mais ne convient pas à toutes les fibres.', wash: 'Lavez selon l’étiquette et vérifiez avant le séchage.', avoid: 'Ne commencez pas avec de l’eau chaude et n’utilisez pas d’enzymes sur la laine ou la soie.' },
        ink: { label: 'encre', first: 'Tamponnez et empêchez l’encre de s’étendre. Placez si nécessaire un chiffon absorbant propre derrière la zone.', driedFirst: 'Ne traitez pas une encre sèche au hasard avec un solvant. Identifiez d’abord le type d’encre si possible.', pre: 'Utilisez un produit indiqué pour le type d’encre et le tissu. Testez toujours sur une zone cachée ; certaines encres ne partent pas complètement.', wash: 'Rincez entièrement le prétraitement et lavez uniquement si l’étiquette le permet.', avoid: 'Ne frottez pas et ne combinez pas différents solvants ou produits de nettoyage.' },
        mud: { label: 'boue', first: 'Laissez d’abord sécher la boue, puis brossez ou grattez doucement autant de terre que possible.', driedFirst: 'Brossez la boue sèche dehors ou au-dessus d’une poubelle sans endommager le tissu.', pre: 'Traitez la zone restante sur un tissu résistant et lavable avec une lessive liquide ou un produit avant lavage adapté.', wash: 'Lavez selon l’étiquette et vérifiez s’il reste une coloration.', avoid: 'N’étalez pas la boue humide et n’utilisez pas de sèche-linge tant que la tache reste visible.' },
      },
      fabrics: { cotton: 'coton ou lin', synthetic: 'tissu synthétique', denim: 'denim', wool: 'laine', silk: 'soie ou tissu très délicat', unknown: 'tissu inconnu' },
      statuses: { fresh: 'une tache fraîche', dried: 'une tache sèche', washed: 'une tache déjà lavée' },
      colors: { light: 'tissu clair', colored: 'tissu coloré', dark: 'tissu foncé' },
      ui: {
        next: 'Suivant', showAdvice: 'Voir mon conseil', homeBadge: 'Traiter prudemment à la maison', woolBadge: 'Prudence accrue avec la laine', professionalBadge: 'Nettoyage professionnel conseillé', unknownBadge: 'Identifiez d’abord le tissu et l’étiquette',
        title: (stain, fabric) => `${capitalizeText(stain)} sur ${fabric}`,
        washedFirst: (driedFirst) => `N’appliquez plus de chaleur. Humidifiez de nouveau délicatement à l’eau fraîche et tamponnez les saletés libérées. ${driedFirst}`,
        washedPre: ' Une tache déjà lavée ou séchée peut nécessiter plusieurs traitements et ne pas disparaître complètement.',
        woolBlood: 'Absorbez l’excédent de sang avec un chiffon absorbant et tamponnez délicatement à l’eau froide.', woolCoffee: 'Rincez doucement une tache de café fraîche à l’eau froide. Tamponnez une zone sèche avec un chiffon non pelucheux et de l’eau tiède.', woolMud: 'Laissez sécher la boue et brossez très délicatement la terre sans tirer sur les fibres.',
        woolPre: 'Tamponnez depuis le bord avec un chiffon non pelucheux et une solution diluée de lessive approuvée pour la laine dans de l’eau tiède. Utilisez peu d’humidité et suivez l’étiquette.', woolWash: 'Lavez uniquement si l’étiquette le permet, avec le programme laine ou lavage à la main indiqué et un produit adapté. Choisissez un nettoyage professionnel si l’étiquette l’exige.', woolAvoid: 'Ne frottez pas, ne tirez pas et n’essorez pas. N’utilisez pas d’enzymes standard, d’eau de Javel ou de solvant au hasard sur la laine.',
        inkWoolFirst: 'Tamponnez seulement l’excédent d’encre avec un chiffon blanc propre et sec. Ne frottez pas et ne détrempez pas.', inkWoolPre: 'N’appliquez pas vous-même de détachant universel ou de solvant sur la laine. Les encres et les finitions de laine réagissent différemment.', inkWoolWash: 'Confiez rapidement le vêtement à un nettoyeur textile professionnel et précisez le type d’encre si vous le connaissez.', inkWoolAvoid: 'Ne frottez pas, ne faites pas tremper et ne combinez pas les produits. La chaleur et les solvants peuvent endommager durablement la tache ou les fibres.',
        silkFirst: 'Tamponnez délicatement l’excédent avec un chiffon blanc propre et sec. Ne frottez pas et ne détrempez pas.', silkPre: 'N’utilisez pas de votre propre initiative un détachant universel, des enzymes, un agent blanchissant ou un solvant. La soie et les finitions délicates peuvent se décolorer ou s’abîmer.', silkWash: 'Suivez uniquement l’étiquette. Si elle indique de ne pas laver ou de nettoyer professionnellement, confiez rapidement le vêtement à un nettoyeur et expliquez l’origine de la tache.', silkAvoid: 'Ne frottez pas, ne faites pas tremper, n’essorez pas, ne séchez pas au sèche-cheveux et ne combinez pas de remèdes ménagers.',
        unknownFirst: 'Tamponnez uniquement l’excédent avec un chiffon blanc propre. Utilisez de l’eau fraîche seulement si l’étiquette autorise un traitement humide.', unknownPre: 'N’appliquez pas encore de produit inconnu. Recherchez l’étiquette et la composition, puis testez tout produit autorisé sur une zone cachée.', unknownWash: 'Lavez seulement lorsque vous savez que le tissu peut être lavé à la maison. Choisissez un professionnel pour un vêtement précieux, sans étiquette ou qui déteint.', unknownAvoid: 'Ne devinez pas la température et n’utilisez pas au hasard agents blanchissants, enzymes ou solvants. Les fibres réagissent différemment.',
        syntheticWash: 'Lavez selon l’étiquette. Les fibres synthétiques peuvent être sensibles à la chaleur ; ne dépassez pas la température indiquée et vérifiez avant le séchage.', denimPre: ' Le denim peut déteindre ; testez le traitement à l’intérieur.', darkAvoid: ' N’utilisez pas d’eau de Javel sur un tissu foncé ; utilisez un produit pour couleurs uniquement si les deux étiquettes l’autorisent.', coloredAvoid: ' Vérifiez la tenue des couleurs et n’utilisez pas d’eau de Javel.', lightAvoid: ' Même sur un tissu clair, un agent blanchissant n’est autorisé que si les deux étiquettes le permettent explicitement.',
        summary: ({ status, stain, color, fabric, professional }) => `Conseil pour ${status} : ${stain} sur ${color}, matière : ${fabric}. ${professional ? 'Éviter les dommages est ici plus important que de poursuivre rapidement le traitement à la maison.' : 'Procédez calmement, testez d’abord et vérifiez le résultat avant d’utiliser de la chaleur.'}`,
        shareMessage: (title) => `Mon plan FashFresh Guide des taches : ${title}. L’étiquette d’entretien reste prioritaire.`, shareTitle: 'FashFresh Guide des taches', shareText: (title) => `Mon plan étape par étape pour ${title.toLowerCase()}. L’étiquette d’entretien reste prioritaire.`, copiedNative: 'Le lien a été copié ; vous pouvez maintenant le coller dans une application.', copied: 'Le lien a été copié.', shareFailed: 'Le partage a échoué. Essayez de copier le lien manuellement.',
      },
    },
  };

  function capitalizeText(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  class FfStainHelper extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      this.form = this.querySelector('[data-ff-form]');
      this.steps = Array.from(this.querySelectorAll('[data-ff-step]'));
      this.nextButton = this.querySelector('[data-ff-next]');
      this.backButton = this.querySelector('[data-ff-back]');
      this.error = this.querySelector('[data-ff-form-error]');
      this.result = this.querySelector('[data-ff-result]');
      this.currentStepOutput = this.querySelector('[data-ff-current-step]');
      this.progress = this.querySelector('[data-ff-progress]');
      this.restartButton = this.querySelector('[data-ff-restart]');
      this.quickButtons = Array.from(this.querySelectorAll('[data-ff-quick-stain]'));
      this.shareButtons = Array.from(this.querySelectorAll('[data-ff-share]'));
      this.shareStatus = this.querySelector('[data-ff-share-status]');
      this.printButton = this.querySelector('[data-ff-print]');
      this.locale = ['en', 'fr'].includes(this.dataset.locale) ? this.dataset.locale : 'nl';
      this.copy = TRANSLATIONS[this.locale];
      this.currentIndex = 0;
      this.resultState = null;

      this.form?.addEventListener('change', (event) => this.handleSelection(event));
      this.nextButton?.addEventListener('click', () => this.goNext());
      this.backButton?.addEventListener('click', () => this.goBack());
      this.restartButton?.addEventListener('click', () => this.restart());
      this.quickButtons.forEach((button) => button.addEventListener('click', () => this.startWithStain(button.dataset.ffQuickStain)));
      this.shareButtons.forEach((button) => button.addEventListener('click', (event) => this.share(event, button.dataset.ffShare)));
      this.printButton?.addEventListener('click', () => this.printResult());
      this.querySelector('[data-ff-product-link]')?.addEventListener('click', () => this.track('ff_stain_helper_product_click', this.resultState));

      if (!this.restoreFromUrl()) this.showStep(0, false);
      this.track('ff_stain_helper_view');
    }

    restoreFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const values = {
        stain: params.get('vlek'),
        fabric: params.get('stof'),
        status: params.get('staat'),
        color: params.get('kleur'),
      };
      let restored = 0;

      Object.entries(values).forEach(([name, value]) => {
        if (!value) return;
        const input = this.form?.querySelector(`input[name="${name}"][value="${CSS.escape(value)}"]`);
        if (input) {
          input.checked = true;
          restored += 1;
        }
      });

      if (restored === 4) {
        this.generateResult({ completion: false });
        if (params.get('shared') === '1') window.FFToolInsights?.push('ff_tool_shared_result_view', { tool: 'vlekkenhulp', result_key: values.stain });
        return true;
      }

      const firstMissing = this.steps.findIndex((step) => !step.querySelector('input:checked'));
      this.showStep(firstMissing >= 0 ? firstMissing : 0, false);
      return restored > 0;
    }

    handleSelection(event) {
      if (!(event.target instanceof HTMLInputElement)) return;
      this.hideError();
      this.updateNextState();
      this.track('ff_stain_helper_select', {
        step: this.steps[this.currentIndex]?.dataset.ffStep,
        value: event.target.value,
      });
    }

    getCurrentSelection() {
      return this.steps[this.currentIndex]?.querySelector('input:checked')?.value || '';
    }

    getSelections() {
      const formData = new FormData(this.form);
      return {
        stain: String(formData.get('stain') || ''),
        fabric: String(formData.get('fabric') || ''),
        status: String(formData.get('status') || ''),
        color: String(formData.get('color') || ''),
      };
    }

    goNext() {
      if (!this.getCurrentSelection()) {
        this.showError();
        return;
      }

      if (this.currentIndex < this.steps.length - 1) {
        this.showStep(this.currentIndex + 1);
        return;
      }

      this.generateResult();
    }

    goBack() {
      if (this.currentIndex > 0) this.showStep(this.currentIndex - 1);
    }

    showStep(index, focus = true) {
      this.currentIndex = Math.max(0, Math.min(index, this.steps.length - 1));
      this.result.hidden = true;
      this.form.hidden = false;
      this.steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== this.currentIndex; });
      this.currentStepOutput.textContent = String(this.currentIndex + 1);
      this.progress.style.width = `${((this.currentIndex + 1) / this.steps.length) * 100}%`;
      this.backButton.hidden = this.currentIndex === 0;
      const nextLabel = this.nextButton.querySelector('[data-ff-next-label]');
      if (nextLabel) {
        nextLabel.textContent = this.currentIndex === this.steps.length - 1
          ? this.copy.ui.showAdvice
          : this.copy.ui.next;
      }
      this.hideError();
      this.updateNextState();

      if (focus) {
        window.requestAnimationFrame(() => {
          const question = this.steps[this.currentIndex]?.querySelector('legend strong');
          question?.setAttribute('tabindex', '-1');
          question?.focus({ preventScroll: true });
        });
      }
    }

    updateNextState() {
      if (!this.nextButton) return;
      this.nextButton.disabled = !this.getCurrentSelection();
    }

    showError() {
      if (this.error) this.error.hidden = false;
      this.steps[this.currentIndex]?.querySelector('input')?.focus();
    }

    hideError() {
      if (this.error) this.error.hidden = true;
    }

    generateResult(options = {}) {
      const selections = this.getSelections();
      if (!this.copy.stains[selections.stain] || !this.copy.fabrics[selections.fabric] || !this.copy.statuses[selections.status] || !this.copy.colors[selections.color]) {
        this.showStep(this.steps.findIndex((step) => !step.querySelector('input:checked')) || 0);
        return;
      }

      const advice = this.buildAdvice(selections);
      this.resultState = { ...selections, ...advice };
      this.form.hidden = true;
      this.result.hidden = false;
      this.currentStepOutput.textContent = '4';
      this.progress.style.width = '100%';

      this.setText('[data-ff-result-title]', advice.title);
      this.setText('[data-ff-result-summary]', advice.summary);
      this.setText('[data-ff-result-first]', advice.first);
      this.setText('[data-ff-result-pre]', advice.pre);
      this.setText('[data-ff-result-wash]', advice.wash);
      this.setText('[data-ff-result-avoid]', advice.avoid);

      const badge = this.querySelector('[data-ff-result-badge]');
      badge.textContent = advice.badge;
      badge.dataset.level = advice.level;
      this.querySelector('[data-ff-product-cta]').hidden = advice.hideProduct;

      this.updateUrl(selections);
      this.updateShareLinks();
      if (options.completion !== false) {
        this.track('ff_stain_helper_result', selections);
        window.FFToolInsights?.complete(this, selections.stain, {
          fabric: selections.fabric,
          status: selections.status,
          color: selections.color,
          advice_level: advice.level,
        });
      }
      window.requestAnimationFrame(() => {
        this.result.scrollIntoView({ behavior: this.reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        this.result.querySelector('h2')?.setAttribute('tabindex', '-1');
        this.result.querySelector('h2')?.focus({ preventScroll: true });
      });
    }

    buildAdvice(selections) {
      const stain = this.copy.stains[selections.stain];
      const statusIntro = this.copy.statuses[selections.status];
      const fabricLabel = this.copy.fabrics[selections.fabric];
      const colorLabel = this.copy.colors[selections.color];
      const ui = this.copy.ui;
      const title = ui.title(stain.label, fabricLabel);
      let level = 'home';
      let badge = ui.homeBadge;
      let first = selections.status === 'fresh' ? stain.first : stain.driedFirst;
      let pre = stain.pre;
      let wash = stain.wash;
      let avoid = stain.avoid;
      let hideProduct = false;

      if (selections.status === 'washed') {
        first = ui.washedFirst(stain.driedFirst);
        pre += ui.washedPre;
      }

      if (selections.fabric === 'wool') {
        level = 'caution';
        badge = ui.woolBadge;
        hideProduct = true;
        if (selections.stain === 'blood') {
          first = ui.woolBlood;
        } else if (selections.stain === 'coffee') {
          first = ui.woolCoffee;
        } else if (selections.stain === 'mud') {
          first = ui.woolMud;
        }
        pre = ui.woolPre;
        wash = ui.woolWash;
        avoid = ui.woolAvoid;

        if (selections.stain === 'ink') {
          level = 'professional';
          badge = ui.professionalBadge;
          first = ui.inkWoolFirst;
          pre = ui.inkWoolPre;
          wash = ui.inkWoolWash;
          avoid = ui.inkWoolAvoid;
        }
      }

      if (selections.fabric === 'silk') {
        level = 'professional';
        badge = ui.professionalBadge;
        hideProduct = true;
        first = ui.silkFirst;
        pre = ui.silkPre;
        wash = ui.silkWash;
        avoid = ui.silkAvoid;
      }

      if (selections.fabric === 'unknown') {
        level = 'professional';
        badge = ui.unknownBadge;
        hideProduct = true;
        first = ui.unknownFirst;
        pre = ui.unknownPre;
        wash = ui.unknownWash;
        avoid = ui.unknownAvoid;
      }

      if (selections.fabric === 'synthetic' && level === 'home') {
        wash = ui.syntheticWash;
      }

      if (selections.fabric === 'denim' && level === 'home') {
        pre += ui.denimPre;
      }

      if (selections.color === 'dark') {
        avoid += ui.darkAvoid;
      } else if (selections.color === 'colored') {
        avoid += ui.coloredAvoid;
      } else {
        avoid += ui.lightAvoid;
      }

      const summary = ui.summary({
        status: statusIntro,
        stain: stain.label,
        color: colorLabel,
        fabric: fabricLabel,
        professional: level === 'professional',
      });

      return { title, summary, first, pre, wash, avoid, level, badge, hideProduct };
    }

    updateUrl(selections) {
      const url = new URL(window.location.href);
      url.searchParams.set('vlek', selections.stain);
      url.searchParams.set('stof', selections.fabric);
      url.searchParams.set('staat', selections.status);
      url.searchParams.set('kleur', selections.color);
      window.history.replaceState({}, '', url);
    }

    updateShareLinks() {
      if (!this.resultState) return;
      const message = this.copy.ui.shareMessage(this.resultState.title);
      const url = new URL(window.location.href); url.searchParams.set('shared', '1'); this.shareUrl = url.toString();
      this.dataset.ffToolResultKey = this.resultState.stain;
      const whatsapp = this.querySelector('[data-ff-share="whatsapp"]');
      const facebook = this.querySelector('[data-ff-share="facebook"]');
      if (whatsapp) {
        whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${message} ${this.shareUrl}`)}`;
        whatsapp.target = '_blank';
        whatsapp.rel = 'noopener';
      }
      if (facebook) {
        facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`;
        facebook.target = '_blank';
        facebook.rel = 'noopener';
      }
    }

    async share(event, platform) {
      if (!this.resultState) {
        event.preventDefault();
        return;
      }
      this.track('ff_stain_helper_share', { platform, stain: this.resultState.stain });
      if (platform === 'whatsapp' || platform === 'facebook') return;
      event.preventDefault();

      const shareData = {
        title: this.copy.ui.shareTitle,
        text: this.copy.ui.shareText(this.resultState.title),
        url: this.shareUrl || window.location.href,
      };

      try {
        if (platform === 'native' && navigator.share) {
          await navigator.share(shareData);
          window.FFToolInsights?.push('ff_tool_share_success', { tool: this.dataset.ffTool, platform: 'native', result_key: this.dataset.ffToolResultKey });
          return;
        }
        await this.copyText(`${shareData.text} ${shareData.url}`);
        this.showShareStatus(platform === 'native' ? this.copy.ui.copiedNative : this.copy.ui.copied);
        window.FFToolInsights?.push('ff_tool_share_success', { tool: this.dataset.ffTool, platform: 'copy', result_key: this.dataset.ffToolResultKey });
      } catch (error) {
        if (error?.name !== 'AbortError') this.showShareStatus(this.copy.ui.shareFailed);
      }
    }

    async copyText(text) {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    showShareStatus(message) {
      if (!this.shareStatus) return;
      this.shareStatus.textContent = message;
      this.shareStatus.hidden = false;
    }

    startWithStain(stain) {
      const input = this.form?.querySelector(`input[name="stain"][value="${CSS.escape(stain)}"]`);
      if (!input) return;
      input.checked = true;
      this.result.hidden = true;
      this.form.hidden = false;
      this.showStep(1, false);
      this.track('ff_stain_helper_quick_start', { stain });
      this.querySelector('.ff-stain-helper__app')?.scrollIntoView({ behavior: this.reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    restart() {
      this.form?.reset();
      this.resultState = null;
      const url = new URL(window.location.href);
      ['vlek', 'stof', 'staat', 'kleur'].forEach((key) => url.searchParams.delete(key));
      url.searchParams.delete('shared');
      window.history.replaceState({}, '', url);
      window.FFToolInsights?.resetRun(this);
      this.showStep(0, false);
      this.track('ff_stain_helper_restart');
      this.querySelector('.ff-stain-helper__app')?.scrollIntoView({ behavior: this.reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    printResult() {
      if (!this.resultState) return;
      this.track('ff_stain_helper_print', { stain: this.resultState.stain });
      window.FFToolInsights?.push('ff_tool_print', { tool: 'vlekkenhulp', result_key: this.resultState.stain });
      window.print();
    }

    setText(selector, value) {
      const element = this.querySelector(selector);
      if (element) element.textContent = value;
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    track(eventName, detail = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    }
  }

  if (!customElements.get('ff-stain-helper')) customElements.define('ff-stain-helper', FfStainHelper);
})();
